import {Component, OnInit} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {WebcamImage, WebcamInitError, WebcamUtil} from 'ngx-webcam';
import {MatDialogRef} from '@angular/material/dialog';
import {ObjektModels} from 'src/app/models/objekt-models';

@Component({
    selector: 'app-camera-viewer',
    templateUrl: './camera-viewer.component.html',
    styleUrls: ['./camera-viewer.component.scss']
})
export class CameraViewerComponent implements OnInit {

    // Properties by TH
    public canSave: boolean = false;
    public imageName: string = 'Aufnahme.jpg';
    public isZoomed = false;
    // toggle webcam on/off
    public showWebcam = true;
    public allowCameraSwitch = true;
    public multipleWebcamsAvailable = false;
    public deviceId: string = '';
    public videoOptions: MediaTrackConstraints = {
        width: {min: 500, ideal: 1920},
        height: {min: 480, ideal: 1080}
    };
    public errors: WebcamInitError[] = [];
    // latest snapshot
    public webcamImage?: WebcamImage;
    private webCamImageData?: ObjektModels.WebCamImageData;
    // webcam snapshot trigger
    private trigger: Subject<void> = new Subject<void>();
    // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
    private nextWebcam: Subject<boolean | string> = new Subject<boolean | string>();

    constructor(public dialogRef: MatDialogRef<CameraViewerComponent>,) {
    }

    public get triggerObservable(): Observable<void> {
        return this.trigger.asObservable();
    }

    public get nextWebcamObservable(): Observable<boolean | string> {
        return this.nextWebcam.asObservable();
    }

    public ngOnInit(): void {
        WebcamUtil.getAvailableVideoInputs().then((mediaDevices: MediaDeviceInfo[]) => {
            this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        });
    }


    public triggerSnapshot(): void {
        this.trigger.next();
    }


    public handleInitError(error: WebcamInitError): void {
        this.errors.push(error);
        console.error('Fehler beim Initialisieren der Kamera: ', error);
    }

    public showNextWebcam(directionOrDeviceId: boolean | string): void {
        // true => move forward through devices
        // false => move backwards through devices
        // string => move to device with given deviceId
        this.nextWebcam.next(directionOrDeviceId);
    }

    public handleImage(webcamImage: WebcamImage): void {
        console.info('received webcam image', webcamImage);
        this.webcamImage = webcamImage;
        this.canSave = true;
    }

    public cameraWasSwitched(deviceId: string): void {
        console.log('active device: ' + deviceId);
        this.deviceId = deviceId;
    }

    clearImage() {
        this.webcamImage = undefined;
        this.canSave = false;
    }

    dataURItoBlob(dataURI: string): Blob {
        // convert base64/URLEncoded data component to raw binary data held in a string
        var byteString;
        if (dataURI.split(',')[0].indexOf('base64') >= 0) {
            byteString = atob(dataURI.split(',')[1]);
        } else {
            byteString = unescape(dataURI.split(',')[1]);
        }

        // separate out the mime component
        var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

        // write the bytes of the string to a typed array
        var ia = new Uint8Array(byteString.length);
        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        return new Blob([ia], {type: mimeString});
    }

    public save() {
        let imageURL = this.webcamImage?.imageAsDataUrl;
        if (imageURL) {
            let imgBlob = this.dataURItoBlob(imageURL);

            this.webCamImageData = {
                imageName: this.imageName,
                imageBlob: imgBlob
            };
            this.dialogRef.close(this.webCamImageData);
        } else {
            this.dialogRef.close(null);
        }
    }
}
